module.exports = __webpack_public_path__ + "static/img/materialsInfo1t2.1226922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo1t2.png
// module id = 6A+2
// module chunks = 2